import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["fieldProps", "proFieldProps"],
    _excluded2 = ["fieldProps", "proFieldProps"];
import { jsx as _jsx } from "react/jsx-runtime";
import ProField from '../Field';
var valueType = 'text';
/**
 * 文本组件
 *
 * @param
 */

var ProFormText = function ProFormText(_ref) {
  var fieldProps = _ref.fieldProps,
      proFieldProps = _ref.proFieldProps,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx(ProField, _objectSpread({
    valueType: valueType,
    fieldProps: fieldProps,
    filedConfig: {
      valueType: valueType
    },
    proFieldProps: proFieldProps
  }, rest));
};

var Password = function Password(_ref2) {
  var fieldProps = _ref2.fieldProps,
      proFieldProps = _ref2.proFieldProps,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return _jsx(ProField, _objectSpread({
    valueType: "password",
    fieldProps: fieldProps,
    proFieldProps: proFieldProps,
    filedConfig: {
      valueType: valueType
    }
  }, rest));
};

var WrappedProFormText = ProFormText;
WrappedProFormText.Password = Password; // @ts-ignore
// eslint-disable-next-line no-param-reassign

WrappedProFormText.displayName = 'ProFormComponent';
export default WrappedProFormText;